import { render, staticRenderFns } from "./treatmentTimeStats.vue?vue&type=template&id=9babb182&scoped=true"
import script from "./treatmentTimeStats.vue?vue&type=script&lang=js"
export * from "./treatmentTimeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9babb182",
  null
  
)

export default component.exports